var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurely(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "securely",
    transform: "translate(-2863 -2647)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "bg",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(2863 2647)",
    fill: "#c5fceb"
  }), /*#__PURE__*/React.createElement("image", {
    id: "Icon_",
    "data-name": "Icon ",
    width: 32,
    height: 38,
    transform: "translate(2877 2658)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAmCAYAAAClI5npAAAABHNCSVQICAgIfAhkiAAAAm5JREFUWEfFmE1IVGEUhhUSK2klhS5KEEJB2hSB0MaVSFIQoRGi/SxEWmQIUqG7UDEIKSgIC/JnoZKB9qOSupIWkQRRkFFgrSQURAw3lj3vcC8Ml3HuHOeb6wcv9++c9zz3zjdzvzPZOe+6s9IYj8jdjy7v1CM7DYDHFG30Cg+xrUP/rCA7ASinyEN0PFBsgeNraNYCYQE4gvFNr0iyGs+42IW+pQISBpCLSSWqQRfRnlRMvZgRttIUWt8uTwB7vYl0gO0hVITK0DF0ChUYiiYKXeHkHPqEvqBF9ButoT8C0GSqR/vSLGRN3yBhVADj7JyxZjuKnxHAMGa1jgytNi8F8IKsc9ZMR/FvBDCG2VlHhlabSQG8Iqvamuko/q0AJjCrcmRotZkWwGuyTlszHcXHnsBuzoEpAehNdsHRHVltxgTwlKyr1kxH8SMCuItZqyNDq80TAdwgq8ea6Si+UwDnMXvuyNBq0yQAvXo/WzMdxVcIIAezVaTFZZRji2L5/oroPQcno6xOre/oqA9wh4P2iAG0EIrNAdU9gT5EDKC1Zuyn2K/7i53DEUFoPZiPNuMBWjhxLyIA3fUt1YoH0OpYZPpWZHocpMByEEDH19H9DFfviJ/wiRqTrwSUZAhiCd/CeO9EAMUE/MgQgPrJj2EAuq4+Qf2Cy3EJs/6gYbLesIHgPkcEzfg8SOQV1pxquT6KLE1psI7avsHtbiQMQHml3qOzvivUiOqxzyd7iqkA+Plt7NxGeSEfyybXtcpSfOiwAMhMrbr+pNBfM8HX91/O9SL9yi2GVvYCrAC+r0D02V5Bmh+a3QPoZ6qF/bj/AAaKO48JJRIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurely);
export default __webpack_public_path__ + "static/media/securely.900ebd675c472c6bef819f55cb7d41b0.svg";
export { ForwardRef as ReactComponent };